import "./Biodata.scss";

export default function BiodataPreview({
  sections = [],
  template,
  userImage,
  forPDF = false,
  onImgLoad = () => {},
}) {

  const PAGE_WIDTH = 560;
  const PAGE_HEIGHT = Math.round(PAGE_WIDTH * 1.414); // A4 ratio;
  const PADDING = 0;

  const SECTION_H = (template?.sectionHeight ?? 60) + 15;
const FIELD_H = 35;
  const maxHeight = PAGE_HEIGHT - PADDING;

  const pages = [];
  let current = [];
  let usedHeight = 0;

  // 🔥 BUILD PAGES ONLY IF SECTIONS EXIST
  if (sections.length > 0) {
    sections.forEach((section) => {
      if (usedHeight + SECTION_H > maxHeight) {
        pages.push(current);
        current = [];
        usedHeight = 0;
      }

      current.push({ type: "section", ...section });
      usedHeight += SECTION_H;

      section.fields.forEach((field) => {
        if (usedHeight + FIELD_H > maxHeight) {
          pages.push(current);
          current = [];
          usedHeight = 0;
        }

        current.push({ type: "field", ...field });
        usedHeight += FIELD_H;
      });
    });

    if (current.length) pages.push(current);
  }

  // 🔥 ALWAYS ENSURE AT LEAST ONE PAGE EXISTS
  const finalPages = pages.length ? pages : [[]];
  const hasMultiplePages = finalPages.length > 1;

  return (
    <div
      className="bd-preview-outer"
      style={{
        height: PAGE_HEIGHT,
        overflowY: hasMultiplePages ? "auto" : "hidden",
        overflowX: "hidden",
      }}
    >
      <div className="bd-preview-inner">
        {finalPages.map((page, pageIndex) => (
          <div
            key={pageIndex}
            className={`bd-page template-${template?.id}`}
            style={{
              width: PAGE_WIDTH,
              height: PAGE_HEIGHT,
              position: "relative",
              marginBottom: hasMultiplePages ? 20 : 0,
              boxSizing: "border-box",
              overflow: "hidden",
              background: "#fff",
            }}
          >
            {/* TEMPLATE BACKGROUND */}
            {template?.img && (
              <img
                src={template.img}
                alt="template"
                draggable={false}
                onLoad={onImgLoad}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "fill",
                  zIndex: 0,
                  pointerEvents: "none",
                }}
              />
            )}

            {/* CONTENT LAYER */}
            <div
              className="bd-content"
              style={{
                position: "relative",
                zIndex: 1,
                height: PAGE_HEIGHT - PADDING * 2,
                padding: PADDING,
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              {/* USER IMAGE */}
              {pageIndex === 0 && userImage && (
                <img
                  src={userImage}
                  className="template-user-img userImage"
                  alt="User"
                />
              )}

              {/* EMPTY STATE */}
              {sections.length === 0 ? (
                <div
                  className="bd-empty-hint"
                  style={{
                    textAlign: "center",
                    marginTop: "50%",
                    transform: "translateY(-50%)",
                    color: "rgba(0,0,0,0.5)",
                    fontStyle: "italic",
                    fontSize: 16,
                  }}
                >
                  Start adding sections to see your biodata ✨
                </div>
              ) : (
                page.map((item) =>
                  item.type === "section" ? (
                    <div
                      key={item.id}
                      className="bd-section-title-preview"
                      style={{ fontSize: 16, marginBottom: 10 }}
                    >
                      {item.title}
                    </div>
                  ) : (
                    <div
                      key={item.id}
                      className="bd-field"
                      style={{
                        display: "flex",
                        marginBottom: 11,
                        fontSize: 14,
                      }}
                    >
                      <div className="bd-label">
                        {item.label} <span>:</span>
                      </div>
                      <div className="bd-value" style={{ flex: 1 }}>
                        {item.value || "-"}
                      </div>
                    </div>
                  )
                )
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
